import React, { useState } from "react";
import { Breadcrumbs as MUIBreadcrumbs, makeStyles, Box, } from "@material-ui/core";
import FTLTooltipPopover from "./FTLTooltipPopover";
import FTLLink from "./FTLLink";
export default ({ items }) => {
    var _a;
    const classes = useStyles();
    const [isHover, setIsHover] = useState(false);
    const [activeLabel, setActiveLabel] = useState(null);
    const [activeElemOffset, setActiveElemOffset] = useState(null);
    const onHover = (label) => {
        setIsHover(true);
        setActiveLabel(label);
    };
    const onLeave = () => {
        setIsHover(false);
        setActiveLabel(null);
    };
    return (React.createElement(Box, { position: "relative" },
        React.createElement(MUIBreadcrumbs, { maxItems: 6, classes: {
                li: classes.item,
                separator: classes.item,
                root: classes.root,
            } }, items.map((item, index) => (React.createElement(FTLLink, { variant: "p2", to: item.to, onMouseEnter: (e) => {
                onHover(item.label);
                const top = e.currentTarget.offsetTop + 20;
                const left = e.currentTarget.offsetLeft;
                setActiveElemOffset({ left, top });
            }, 
            // ref={activeRef}
            onMouseLeave: onLeave, key: index }, item.label)))),
        isHover && activeLabel && (React.createElement(FTLTooltipPopover, { style: {
                left: `${activeElemOffset === null || activeElemOffset === void 0 ? void 0 : activeElemOffset.left}px`,
                top: `${(_a = activeElemOffset === null || activeElemOffset === void 0 ? void 0 : activeElemOffset.top) !== null && _a !== void 0 ? _a : 0}px`,
            }, wait: 300, title: activeLabel }))));
};
const useStyles = makeStyles((theme) => ({
    root: {
        "& li[class*=PrivateBreadcrumbCollapsed]": {
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: "transparent",
            marginTop: "auto",
        },
    },
    item: {
        display: "block",
        maxWidth: "230px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        "& a > span": {
            color: `${theme.palette.text.breadcrumbs} !important`,
        },
    },
}));
//# sourceMappingURL=FTLBreadcrumbs.js.map